module.exports = __webpack_public_path__ + "static/media/agrandar_manualmente_ventana.2c0380a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallRecord/agrandar_manualmente_ventana.svg
// module id = 1734
// module chunks = 0